module.exports = __webpack_public_path__ + "img/sketches.fc5d7ae9.jpg";